// Card de shadcn, copiada al repo y adaptada al panel de identidad sobre base
// slate: superficie #1E293B opaca, borde hairline, radio 8px y NADA de blur ni
// sombra. El panel translucido con blur es solo para cuando hay mapa debajo
// (fleet-map); sobre fondo plano, el panel es opaco (base.css).
//
// Altura natural: la card crece con el contenido, nunca recorta. `p-0` por
// props la deja como contenedor de una tabla o de una lista densa.
import { cn } from "./cn.js";

type PropsDiv = React.HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...props }: PropsDiv): React.JSX.Element {
  return (
    <div
      className={cn("flex h-auto flex-col gap-4 rounded-lg border border-linea bg-superficie p-5", className)}
      {...props}
    />
  );
}

/**
 * Cabecera de panel de identidad: rotulo en mayusculas con tracking y, a la
 * derecha, lo que acompana (contador, "Ver mas", filtros). Va pegada arriba
 * de una Card con `p-0`, con el divisor hairline.
 */
export function CardHeader({ className, ...props }: PropsDiv): React.JSX.Element {
  return <div className={cn("flex flex-col gap-1", className)} {...props} />;
}

export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>): React.JSX.Element {
  return (
    <h2
      className={cn("m-0 text-lg font-semibold leading-titulo tracking-titulo text-texto", className)}
      {...props}
    />
  );
}

export function CardDescription({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>): React.JSX.Element {
  return <p className={cn("m-0 text-xs leading-normal text-texto-suave", className)} {...props} />;
}

export function CardContent({ className, ...props }: PropsDiv): React.JSX.Element {
  return <div className={cn("flex flex-col gap-3", className)} {...props} />;
}

/**
 * Cabecera densa de panel (readme de identidad: rotulo de panel en
 * mayusculas, 40px de alto, divisor abajo). `children` va a la derecha.
 */
export function PanelHeader({
  title,
  count,
  id,
  className,
  children,
}: {
  title: React.ReactNode;
  /** Contador al lado del rotulo, en tinta fuerte. */
  count?: number | string | undefined;
  id?: string;
  className?: string;
  children?: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className={cn("flex min-h-10 items-center justify-between gap-3 border-b border-divisor px-3.5 py-2", className)}>
      {/* El contador queda fuera del nombre accesible de la region: "Avisos", no "Avisos 3". */}
      <div className="rotulo flex items-center gap-2 text-texto-suave">
        <h2 id={id} className="m-0 text-inherit">
          {title}
        </h2>
        {count !== undefined && <b className="font-semibold tracking-normal text-texto">{count}</b>}
      </div>
      {children !== undefined && <div className="flex items-center gap-3 text-xs text-texto-suave">{children}</div>}
    </div>
  );
}
